import { OpenPosition } from './types'

export const openPositions: OpenPosition[] = [
  {
    id: 1,
    title: 'Sales & Quality Coach',
    description: (
      <>
        <p>
          Bolt is het allereerste energieplatform in België dat het mogelijk én gemakkelijk maakt om rechtstreeks energie te kopen van
          lokale, groene opwekkers. Bijvoorbeeld van de zonnepanelen van Nico of van de boerderij van Valerie en Frederik. Op die manier
          weet je als klant zeker waar jouw energie vandaan komt - en dus echt groen is - en waar je geld naartoe gaat.
          <br />
          <br />
          Waarom doet Bolt dat? De energiemarkt is vandaag niet transparant. Traditionele leveranciers verkopen grijze energie als groene,
          en helpen ons land niet verduurzamen. Dat wil Bolt veranderen!
          <br />
          <br />
          Wij zijn op zoek naar een Sales &amp; Quality Coach om ons sales team te versterken. Bolt pakt sales anders aan. We willen de
          energiemarkt niet alleen transparanter en duurzamer maken, maar ook persoonlijker. Onze klanten weten wie hun energie opwekt. Die
          persoonlijke aanpak trekken we door in heel ons bedrijf: in marketing en communicatie, in service, en uiteraard ook in sales.
          <br />
          <br />
          Als Sales &amp; Quality Coach ben jij dé contactpersoon voor onze salespartners. Jij staat in voor de kwaliteit van hun geleverde
          prestaties en neemt actie waar nodig, om onze sales zo Bolt mogelijk te maken. Je zorgt mee voor de groei van het bedrijf op een
          kwalitatieve manier.
        </p>
        <h3>Wat we verwachten van jou:</h3>
        <ul>
          <li>Je beantwoordt vragen van de partners via telefoon en e-mail</li>
          <li>Je beluistert en beoordeelt salesgesprekken</li>
          <li>Je geeft onze partners tips en tricks om het beter te doen</li>
          <li>Je belt zelf ook regelmatig met (ex)klanten</li>
          <li>Je staat in voor het behalen van vooropgestelde targets rond kwaliteit</li>
          <li>Je bent ambitieus en werkt oplossingsgericht</li>
          <li>Je wil impact maken op vlak van duurzaamheid</li>
          <li>Je hebt minimum 2 jaar ervaring in sales, idealiter in de energiesector</li>
          <li>Je kan je goed uitdrukken in het Nederlands en Frans</li>
          <li>Je staat stevig in je schoenen en denkt graag mee aan oplossingen</li>
        </ul>
        <h3>Wat jij mag verwachten van ons:</h3>
        <ul>
          <li>Je wordt de stem van Bolt naar onze salespartners toe</li>
          <li>
            Een boeiende job binnen een jonge, dynamische start-up. Je staat mee aan de basis van het uitbouwen van ons platform en
            ‘changemaking’ op vlak van energie in ons land
          </li>
          <li>Een werkplek met uitzicht over Brussel, afgewisseld met werk op afstand</li>
          <li>Een loonpakket met extralegale voordelen</li>
        </ul>
        <h3>Hoe kan jij solliciteren?</h3>
        <p>
          Stuur je CV en een korte motivatie zo snel mogelijk naar <a href="mailto:rowena@boltenergie.be">rowena@boltenergie.be</a>.
        </p>
      </>
    )
  },
  {
    id: 2,
    title: 'Customer Care Hero (NL)',
    description: (
      <>
        <h3>Wat verwachten we van onze Customer Care Hero?</h3>
        <p>
          Als Customer Care Hero ben jij dé <strong>contactpersoon voor onze klanten</strong>. Via telefoon en e-mail beantwoord je vragen
          over onder andere de opbouw van facturen, hun contract, verhuizingen en andere zaken die hen bezig houden. Jij staat onze huidige
          én potentiële klanten te woord, luistert naar hen, begrijpt het probleem en zoekt naar de perfecte oplossing. Je zorgt mee voor de{' '}
          <strong>op-en-top klantenervaring</strong> voor de klant bij alle contactpunten.
        </p>
        <h3>Concreet gekeken doe je dus volgende zaken:</h3>
        <ul>
          <li>Je beantwoordt klantvragen via telefoon en e-mail</li>
          <li>Je verzorgt mee de first-line contactmomenten met onze klanten en prospecten</li>
          <li>
            Je verwerkt gestelde vragen en problemen in ons systeem en bent zelf verantwoordelijk voor de volledige opvolging en behandeling
            van de vraag
          </li>
          <li>Je enthousiasmeert klanten over Bolt en onze missie</li>
        </ul>
        <h3>Wat moet onze droom Customer Care Hero in zijn mars hebben?</h3>
        <ul>
          <li>Je hebt een assertieve houding en empathische instelling, je denkt graag mee met de klant.</li>
          <li>
            Je wilt vooral <strong>mensen helpen</strong> bij problemen waar ze mee zitten. Een tevreden klant maakt jouw dag helemaal goed!
          </li>
          <li>Je hebt de ambitie persoonlijk te groeien binnen Bolt en ons CC team</li>
          <li>
            Je werkt <strong>zelfstandig</strong> en staat stevig in je schoenen.
          </li>
          <li>
            Je wilt een bijdrage leveren aan het <strong>verduurzamen</strong> van België.
          </li>
          <li>
            Je bent communicatief vaardig en hebt een goede beheersing van de Nederlandse taal. Kennis van Frans is een groot pluspunt.
            Kennis van het Engels (als voertaal binnen ons meertalige team) is een must!
          </li>
        </ul>
        <h3>En wat hebben wij jou te bieden?</h3>
        <ul>
          <li>
            Je wordt deel van een <strong>start-up</strong> en wordt voluit betrokken in ons ecosysteem!
          </li>
          <li>
            Je komt te weten hoe het groeien van start-up naar scale-up in zijn werk gaat door close contact met alle leden van het team
          </li>
          <li>
            Je wordt deel van ons <strong>kernteam</strong> en groeit mee met ons bedrijf
          </li>
          <li>
            Je wordt <strong>dé stem van Bolt</strong> en hebt een rechtstreekse impact op de customer experience en de missie van Bolt!
          </li>
          <li>Wij bieden je natuurlijk ook een mooie verloning met mooie voordelen, die past bij de functie.</li>
        </ul>
        <h3>Contact</h3>
        <p>Geïnteresseerd of vragen?</p>
        <p>
          Pjotr Hubin
          <br />
          <a href="mailto:pjotr@boltenergie.be?subject=Vacature Customer Care Hero (NL)">pjotr@boltenergie.be</a>
        </p>
      </>
    )
  },
  {
    id: 3,
    title: 'Customer Care Student (NL)',
    description: (
      <>
        <h3>Wie zoeken wij?</h3>
        <p>
          Als student in het <strong>Customer Care team</strong> ben jij <strong>dé contactpersoon voor onze klanten</strong>. Via de
          telefoon sta je klaar voor onze huidige én potentiële klanten. Je luistert naar hen, begrijpt het probleem en zoekt naar de
          perfecte oplossing. Je zorgt mee voor de <strong>op-en-top klantervaring</strong>.
        </p>
        <h3>Hoe moet dat?</h3>
        <ul>
          <li>Je beantwoordt klantvragen via de telefoon</li>
          <li>Je verzorgt mee de first-line contactmomenten met onze klanten en prospecten</li>
          <li>Je verwerkt gestelde vragen en problemen in ons systeem</li>
          <li>Je enthousiasmeert klanten over Bolt en onze missie.</li>
        </ul>
        <h3>Wie ben jij?</h3>
        <ul>
          <li>Je hebt een assertieve houding en empathische instelling, je denkt graag mee met de klant.</li>
          <li>
            Je wilt vooral <strong>mensen helpen</strong> bij problemen waar ze mee zitten. Een tevreden klant maakt jouw dag helemaal goed!
          </li>
          <li>
            Je wilt een bijdrage leveren aan het <strong>verduurzamen</strong> van België.
          </li>
          <li>
            Je bent communicatief vaardig en hebt een goede beheersing van de Nederlandse taal. Kennis van Frans is een groot pluspunt.
            Kennis van het Engels (als voertaal binnen ons meertalige team) is een must!
          </li>
        </ul>
        <h3>En wat hebben wij jou te bieden?</h3>
        <ul>
          <li>
            Een <strong>atypische studentenjob</strong>
          </li>
          <li>
            <strong>Flexibele uren</strong> aangepast aan je lessenrooster, op kantoor of thuis achter je eigen bureau
          </li>
          <li>Een eerste keer proeven van de werking binnen een start-up</li>
          <li>We betrekken je binnen het kernteam, waar jij een deeltje van bent!</li>
          <li>
            Je wordt <strong>dé stem van Bolt</strong> en hebt een rechtstreekse impact op de customer experience en de missie van Bolt!
          </li>
        </ul>
        <h3>Hoe solliciteren?</h3>
        <p>
          Krijg jij hier alleen maar positieve energie van? Grijp dan zeker je kans en stuur een mailtje naar&nbsp;
          <a href="mailto:charlotte@boltenergie.be?subject=Vacature Customer Care Student (NL)">charlotte@boltenergie.be</a>.
        </p>
      </>
    )
  },
  {
    id: 4,
    title: 'Customer Care Student (FR)',
    description: (
      <>
        <h3>Étudiant pour le service clientèle</h3>
        <p>
          En tant qu’étudiant de l’équipe `Customer Care`, tu es la personne de contact pour nos clients. Au téléphone, tu es là pour nos
          clients actuels et potentiels. Tu les écoutes, comprends le problème et cherches la solution parfaite. Tu contribues à garantir la
          meilleure expérience possible pour le client.
        </p>
        <h3>Ton rôle :</h3>
        <ul>
          <li>Tu réponds aux questions des clients par téléphone</li>
          <li>Tu es impliqué dans le contact de première ligne avec nos clients et prospects</li>
          <li>Tu traites les questions et problèmes dans notre système</li>
          <li>Tu fais en sorte que les clients s’enthousiasment pour Bolt et notre mission.</li>
        </ul>
        <h3>Qui es-tu?</h3>
        <ul>
          <li>Tu as une attitude assertive et empathique, tu aimes réfléchir avec le client..</li>
          <li>Tu veux surtout aider les gens à résoudre leurs problèmes. Un client satisfait fait ta journée !</li>
          <li>Tu veux contribuer à rendre la Belgique plus durable.</li>
          <li>
            Tu as de bonnes capacités de communication et une bonne maîtrise de la langue française. La connaissance du néerlandais est un
            atout majeur. La connaissance de l’anglais (en tant que langue de travail au sein de notre équipe multilingue) est un must !
          </li>
        </ul>
        <h3>Et qu’avons-nous à offrir ?</h3>
        <ul>
          <li>Un job d’étudiant atypique</li>
          <li>Des horaires flexibles adaptés à ton emploi du temps, au bureau ou à la maison derrière ton propre bureau.</li>
          <li>Un premier aperçu du fonctionnement d’une start-up</li>
          <li>Nous t’impliquons dans l’équipe centrale, dont tu fais partie !</li>
          <li>Tu seras la voix de Bolt et auras un impact direct sur l’expérience client et la mission de Bolt !</li>
        </ul>
        <h3>Comment postuler ?</h3>
        <p>
          Cela ne vous a donné que de l’énergie positive ? Alors saisissez votre chance et envoyez un courriel à &nbsp;
          <a href="mailto:fany@boltenergie.be?subject=Vacature Customer Care Student (NL)">fany@boltenergie.be</a>.
        </p>
      </>
    )
  },
  {
    id: 5,
    title: 'Bolt Sales Ambassador (NL)',
    description: (
      <>
        <p>
          Om onze community in Vlaanderen te vergroten, willen we ons in de toekomst vertegenwoordigen met een vast team aan sales talenten.
          Herken jij jezelf in de volgende puntjes? Dan ben jij misschien de verkoper naar wie wij op zoek zijn.
        </p>
        <p>
          Je zal samen met je team instaan voor de ontwikkeling van de Bolt community, voor zowel particulieren als kleine professionals.
        </p>
        <h3>We zijn op zoek naar ambitieuze verkopers, maar niet alleen dat, je bent ook:</h3>
        <ul>
          <li>Bewust van de noodzakelijke energietransitie, en je wilt er deel van uitmaken</li>
          <li>Thuis in korte keten en past dit toe in je dagelijks leven</li>
          <li>Geërgerd aan de gebruikelijke commerciële praktijken in de energiesector</li>
          <li>Overtuigd dat wat je doet zin heeft en maakt dat op een overtuigende manier duidelijk</li>
          <li>Communicatief en commercieel in hart en nieren voor de lange termijn</li>
          <li>Comfortabel in het werven van particuliere en/of kleine professionele klanten</li>
          <li>Houder van een BTW-nummer (of in het proces naar...)</li>
        </ul>
        <h3>Wij bieden jou aan:</h3>
        <ul>
          <li>
            Een nieuwe manier om een energiecontract aan te bieden: stoppen met de eenmalige verkoop enkel gebaseerd op basis van de prijs,
            maar in tegenstelling daarvan een duurzame en transparante oplossing voorstellen
          </li>
          <li>
            De mogelijkheid om een merk te vertegenwoordigen dat door Greenpeace wordt aanbevolen als het gaat over positieve acties binnen
            de energietransitie in België
          </li>
          <li>Een back-office aan de top en geëngageerd in wat ze doen</li>
          <li>Een follow-up in de opleiding en de ondersteuning van de verkoop</li>
          <li>Doeltreffende communicatie om lokaal nieuwe opportuniteiten te ontwikkelen</li>
          <li>Tools die toelaten om de verkoop in goede banen te leiden</li>
          <li>Een eenvoudig commissieplan</li>
          <li>Een carrièreplan om te evolueren binnen Bolt (ontwikkeling van relaties met hernieuwbare producenten, coaching, enz.)</li>
        </ul>
        <h3>Hoe kan jij solliciteren?</h3>
        <p>
          Als je denkt dat jij het ideale profiel hebt om ons jonge team te vervoegen, of nieuwsgierig bent om meer te weten, aarzel dan
          niet om contact op te nemen via{' '}
          <a href="mailto:pieterjan@boltenergie.be?subject=Vacature Bolt Sales Ambassador (NL)">pieterjan@boltenergie.be</a>
        </p>
      </>
    )
  },
  {
    id: 6,
    title: 'Bolt Sales Ambassador (FR)',
    description: (
      <>
        <p>
          Afin de développer notre communauté en Wallonie, nous voulons avant tout une équipe fixe de commerciaux, c’est pourquoi nous
          limitons le nombre de places disponibles.
        </p>
        <p>Vous serez en charge de développer la communauté Bolt auprès des particuliers et petits professionnels.</p>
        <h3>Nous recherchons des commerciaux ambitieux, mais pas seulement</h3>
        <p>Vous êtes:</p>
        <ul>
          <li>Conscient de la transition énergétique nécessaire, et vous voulez y participer</li>
          <li>Engagé car la consommation en circuit-court est déjà présente dans votre vie quotidienne</li>
          <li>Agacé par les pratiques commerciales habituelles dans le secteur de l’énergie</li>
          <li>Convainquant lorsque vous êtes convaincu vous-même que ce que vous faites a du sens !</li>
          <li>
            Communicateur d’enthousiasme et commercial dans l’âme impliqué sur le long terme A l’aise dans le démarchage des prospects
            particuliers et/ou petits professionnels
          </li>
          <li>Titulaire d’un numéro de TVA (ou en cours de...)</li>
        </ul>
        <h3>Nous offrons :</h3>
        <ul>
          <li>
            Une nouvelle manière de proposer un contrat d’énergie : stop à la vente one-shot seulement basée sur du prix, vous proposez une
            solution durable et transparente
          </li>
          <li>
            La possibilité de représenter une marque conseillée par Greenpeace pour son action dans la transition énergétique en Belgique
          </li>
          <li>Un back-office au top et engagés dans ce qu’ils font, un suivi dans la formation et le soutien à la vente</li>
          <li>Une communication performante afin de développer de nouvelles opportunités localement</li>
          <li>Des outils permettant de vendre sereinement</li>
          <li>Un plan de commissionnement simple, fixe et juste</li>
          <li>
            Un plan de carrière afin d’évoluer au sein de Bolt (développement des relations avec les producteurs de renouvelable, coaching,
            etc...)
          </li>
        </ul>
        <h3>Comment pouvez-vous postuler?</h3>
        <p>
          Si vous pensez avoir le profil pour rejoindre notre jeune équipe, ou curieux d’en savoir d’avantage, n’hésitez pas à prendre
          contact via l’adress email{' '}
          <a href="mailto:pieterjan@boltenergie.be?subject=Vacature Bolt Sales Ambassador (FR)">pieterjan@boltenergie.be</a>
        </p>
      </>
    )
  }
]
